<ion-app>
  <ion-router-outlet></ion-router-outlet>
  
  <!-- Desktop: Persistent nav bar at app level (overlays content, never animates with pages) -->
  <app-nav-bar 
    *ngIf="isDesktopViewport" 
    [standalone]="true"
    [class.nav-bar-hidden]="hideNavBar"
    (authRequired)="openAuthModal($event)"
    (addListingClick)="onAddListingClick($event)">
  </app-nav-bar>
</ion-app>
